import { useCallback } from 'react';
import { notification } from 'components/index';
import { ErrorMappingValueType } from 'typings';
import { useContactPersonDeleteMutation } from 'api';

export const useDeleteModal = (onDeleteModalClose: () => void) => {
  const [notificationApi, contextHolder] = notification.useNotification();
  const [contactPersonDelete, { isLoading }] = useContactPersonDeleteMutation();
  const openNotificationWithIcon = useCallback(
    (messageContent: ErrorMappingValueType) => {
      const { type, message } = messageContent;
      notificationApi[type]({ message: message });
    },
    [notificationApi]
  );

  const onRemoveConfirm = useCallback(
    async (contactPerson: { id: string | undefined }) => {
      try {
        const { data, error }: any = await contactPersonDelete({
          id: contactPerson.id as string,
          entity: 'SUPPLIER',
        });
        if (data?.success) {
          openNotificationWithIcon({
            type: 'success',
            message: `The contact person was successfully deleted.`,
          });
          onDeleteModalClose();
        } else if (error?.data?.success === false) {
          const { data = {} } = error.data;
          Object.keys(data).forEach((_key: string) => {
            openNotificationWithIcon({
              type: 'error',
              message: data[_key],
            });
          });
        } else {
          openNotificationWithIcon({
            type: 'error',
            message: error?.data?.error || 'Something went wrong!',
          });
        }
      } catch {
        openNotificationWithIcon({
          type: 'error',
          message: 'An unexpected error occurred!',
        });
      }
    },
    [contactPersonDelete, openNotificationWithIcon, onDeleteModalClose]
  );

  return {
    onRemoveConfirm,
    contextHolder,
    isLoading,
  };
};
